import { importVehiclesTypes } from "../actions/importVehicles.types";
export interface EnsureValidValue<T> {
  value: T;
  isValid: boolean;
  errorMessageKey?: vehicleErrorType
}

export interface VehicleData {
  country: EnsureValidValue<string>;
  numberPlate: EnsureValidValue<string>;
  description: EnsureValidValue<string>;
  lineNumber?: number;
}

export interface ProductSchedule {
  pmcId: number;
  activationDate: Date | null;
  expirationDate: Date | null;
}

export interface ImportVehiclesState {
  data: VehicleData[];
  products: ProductSchedule[];
  processing: boolean;
  hasWhitelistChanges: boolean;
}

export const initialState: ImportVehiclesState = {
  data: [],
  products: [],
  hasWhitelistChanges: false,
  processing: false,
};

export type ImportVehiclesAction = {
  type: string;
  payload?: VehicleData | VehicleData[] | ProductSchedule[] | boolean;
};

export default (
  state: ImportVehiclesState = initialState,
  action: ImportVehiclesAction
): ImportVehiclesState => {
  switch (action.type) {
    case importVehiclesTypes.SET_VEHICLES_DATA:
      return {
        ...state,
        data: action.payload as VehicleData[],
      };
    case importVehiclesTypes.SET_VEHICLES_PROCESSING:
      return {
        ...state,
        processing: action.payload as boolean,
      };
    case importVehiclesTypes.SET_SELECTED_PRODUCTS:
      return {
        ...state,
        products: action.payload as ProductSchedule[],
      };
    case importVehiclesTypes.SET_WHITELIST_CHANGES:
      return {
        ...state,
        hasWhitelistChanges: action.payload as boolean,
      };
    case importVehiclesTypes.RESET_VEHICLES:
      return initialState;
    default:
      return state;
  }
};

export type vehicleErrorType = "invalidCountryCode" | "invalidNumberPlate" | "invalidDescriptionLength" |
  "invalidGermanNumberPlate" | "missingNumberPlate" | "missingCountryCode" | "duplicatedNumberPlate";
